export default __webpack_public_path__ + "e5827ef4eefdb892d16237d8c8a3e968.mp3";